import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ICmsUtilSimpleAbstractComponent } from '@icms/admin/util/simple/icms-admin-util-simple.abstract.component';
import { BehaviorSubject } from 'rxjs';
@Component({
    standalone: false,
    selector: 'icms-timepicker',
    templateUrl: 'icms-timepicker.html',
    styleUrls: ['icms-timepicker.scss']
})
export class ICmsTimepickerComponent extends ICmsUtilSimpleAbstractComponent implements OnInit, OnChanges {
    /**
     * If triangle should be printed
     */
    @HostBinding('class._triangle')
    @Input()
    triangle: boolean = false;

    /**
     * Open state
     */
    @Input()
    openState?: BehaviorSubject<boolean>;

    /**
     * Time model
     */
    @Input()
    model?: string;

    /**
     * Model change
     */
    @Output()
    modelChange = new EventEmitter<string>();

    protected hour = '00';
    protected minute = '00';
    protected isMinute = false;

    protected amHours = Array.from({ length: 12 }, (_, i) => (i + 1).toString());
    protected pmHours = Array.from({ length: 12 }, (_, i) => (i === 11 ? 0 : i + 13).toString().padStart(2, '0'));
    protected minutes = Array.from({ length: 12 }, (_, i) => (i === 11 ? 0 : (i + 1) * 5).toString().padStart(2, '0'));

    override ngOnChanges(changes: SimpleChanges) {
        if (changes['model']) {
            // normalize model to avoid difference when value isnt set
            if (!this.model) {
                this.model = undefined;
            }
            const [hour, minute] = (this.model || ':').split(':');
            this.hour = hour;
            this.minute = minute;
        }
        super.ngOnChanges(changes);
    }

    override ngOnInit() {
        super.ngOnInit();
    }

    protected pickHour(hour: string) {
        this.hour = hour.padStart(2, '0');
        this.isMinute = true;
        // without update to not close the picker, in case update on off click
        this.detectChanges();
    }

    protected pickMinutes(minute: string) {
        this.minute = minute.padStart(2, '0');
        this.finishSelection();
        this.detectChanges();
    }

    protected finishSelection() {
        console.log('finishSelection');
        this.isMinute = false;
        this.updateModel();
    }

    private updateModel(): void {
        const model = this.hour && this.minute ? this.hour + ':' + this.minute : undefined;
        if (model !== this.model) {
            this.model = model;
            this.modelChange.emit(this.model);
        }
    }

    protected setIsMinute(isMinute: boolean): void {
        if (this.isMinute !== isMinute) {
            this.isMinute = isMinute;
            this.detectChanges();
        }
    }

    /**
     * Checks if given hour or minute is the same as reference
     * where reference is currently picked hour or minute
     *
     * We neee to check this way cause we may padd hour or minute with 0
     * what will cause difference in string
     */
    protected isSelected(i: string, ref: string): boolean {
        return ref ? parseInt(i, 0) === parseInt(ref, 0) : false;
    }

    /**
     * This method is used to check if given shield is one that
     * has currently selected hour or minute
     *
     * We need to show pointer only if shield has selection
     */
    protected isCurrentShield(items: string[], ref: string | undefined): boolean {
        return items.some(i => this.isSelected(i, ref || ''));
    }

    /**
     * Gets currently selected item index
     */
    protected currentIndex(items: string[], ref: string | undefined): number {
        const index = items.findIndex(i => this.isSelected(i, ref || '')) + 1;
        return index == 12 ? 0 : index;
    }
}
